import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DataChashingService {

  public templates: any = {};
  pages: any = {};
  menus: any = {};
  blogs: any = {};
  components: any = {};
  menusCategories: any = {};



  constructor() { }

}
